import { $inputRule } from "@milkdown/kit/utils";
import { InputRule } from "@milkdown/kit/prose/inputrules";

import { withMeta } from "../__internal__";

/**
 * Input rule to convert --- to em-dash (—)
 * Triggers when typing --- followed by a space or at end of input
 */
export const emDashInputRule = $inputRule(() => {
  return new InputRule(/---$/, (state, match, start, end) => {
    return state.tr.replaceWith(start, end, state.schema.text("—"));
  });
});

withMeta(emDashInputRule, {
  displayName: "InputRule<emDash>",
  group: "Typography",
});

/**
 * Input rule to convert -- followed by space to en-dash + space (– )
 * Requires a space after -- to trigger, allowing --- for em-dash to work
 * This matches Pandoc's smart punctuation behavior
 */
export const enDashInputRule = $inputRule(() => {
  return new InputRule(/(?<!-)-- $/, (state, match, start, end) => {
    return state.tr.replaceWith(start, end, state.schema.text("– "));
  });
});

withMeta(enDashInputRule, {
  displayName: "InputRule<enDash>",
  group: "Typography",
});

/**
 * Input rule to convert ... to ellipsis (…)
 */
export const ellipsisInputRule = $inputRule(() => {
  return new InputRule(/\.\.\.$/, (state, match, start, end) => {
    return state.tr.replaceWith(start, end, state.schema.text("…"));
  });
});

withMeta(ellipsisInputRule, {
  displayName: "InputRule<ellipsis>",
  group: "Typography",
});
